import axios from "axios";
import {
  setNotificationsLoading,
  setNotifications,
  setNotificationsError,
  markNotificationRead,
} from "./reducer";

export const fetchNotifications = () => async (dispatch: any) => {
  try {
    dispatch(setNotificationsLoading());
    const response = await axios.get(
      `/notifications/user_notifications?page_size=10`,
      { withCredentials: true }
    );
    if (response.status === "SENT") {
      dispatch(setNotifications(response.notifications));
    }
  } catch (error: any) {
    if (error.response?.status === 403) {
      setTimeout(() => { window.location.href = "/logout"; }, 2000);
      dispatch(setNotificationsError("Session expired!"));
    } else {
      dispatch(setNotificationsError(error.response?.data?.error || "An error occurred"));
    }
  }
};

export const markNotificationAsRead = (notificationId: number) => async (dispatch: any) => {
  try {
    dispatch(markNotificationRead(notificationId));
    await axios.patch(`/notifications/${notificationId}/mark_read/`);
    dispatch(fetchNotifications());
  } catch (error) {
    console.log("Error marking notification as read", error);
  }
};
